module.exports = __webpack_public_path__ + "static/img/pm25.fe64e052.jpg";